// Suppress ResizeObserver loop completed with undelivered notifications error from Element Plus
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {faSignOutAlt, faSync, faUser, faFileExcel, faFilePdf, faPencil, faCheck, faCancel, faTrash, faPlus} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import apiClient from "@/services/apiClient";
import { BootstrapVue3 } from "bootstrap-vue-3";
import 'bootstrap/dist/css/bootstrap.css';
import Notifications from '@kyvg/vue3-notification'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import "vue-multiselect/dist/vue-multiselect.min.css";
import './assets/styles.css'
library.add(faSignOutAlt, faUser, faSync, faFileExcel, faFilePdf,faPencil, faCheck, faCancel, faTrash, faPlus);
const app = createApp(App);
app.use(Notifications)
app.use(BootstrapVue3)
app.config.globalProperties.$http = apiClient;
app.use(router);
app.use(ElementPlus);
app.use(BootstrapVue3);
app.component("font-awesome-icon", FontAwesomeIcon);
app.mount("#app");

